export default __webpack_public_path__ + "static/media/walletConnect.a4166a89.svg";